import { queryOptions } from '@tanstack/react-query'
import { apiClient } from '~/lib/client'
// import { queryClient } from '~/main'

import { handleApiError } from '~/utils/response'
import { handleResponse } from '~/utils/response'

import { sessionKeys } from './keys'
import { queryClient } from '~/main'
// import { useOnboardingSessionStore } from '../../store/complete-onboarding-session-store'

interface Medication {
  category: string
  medication: string
  quantity: string
  instructions: string[]
  is_primary: boolean
  is_secondary: boolean
  is_extra: boolean
}

interface TreatmentPage {
  red_flag_questions: string[]
  medications: Medication[]
  additional_question: string
}

interface Diagnosis {
  disease_name: string
  image_prompt: string
  overview: string
  symptoms: string[]
  red_flags: string[]
  diagnosis: string[]
  causes: string[]
  prevention: string[]
  treatment_page: TreatmentPage
  general_questions: string[]
  disease_id: string
  affected_area: string[]
  image_urls: string[]
}

interface Session {
  user_id: string
  session_id: string
  session_number: number
  session_type: string
  start_datetime: string
  thread_id: string
  agent_id: string
  status: string
  onboard_session: string
  alfie_session: string
  treatment_completed: boolean
  is_red_flagged: boolean
  created_at: number
  metadata: Record<string, unknown>
  diagnosis?: Diagnosis[]
}

interface GetSessionsResponse {
  status: string
  message: string | null
  sessions: Session[]
}

interface GetSessionByIdResponse {
  status: string
  message: string | null
  session_overview: {
    session: Session
    consultation: Record<string, unknown>
    appointments: unknown[]
    notes: unknown[]
  }
}

export const sessionsQueryOptions = () => {
  return queryOptions({
    queryKey: sessionKeys.sessions(),
    retry: false,
    queryFn: async () => {
      try {
        const response = await apiClient('/sessions')
        const result = await handleResponse<GetSessionsResponse>(response)
        if (!result.success) {
          throw new Error(result.error)
        }
        return result.data
      } catch (error) {
        handleApiError(error)
      }
    }
  })
}

export const sessionChatHistory = () => {
    return queryOptions({
        queryKey: sessionKeys.sessions(),
        retry: false,
        queryFn: async () => {
          try {
            const response = await apiClient('/sessions/{session_id}/chat-history')
            const result = await handleResponse<GetSessionsResponse>(response)
            if (!result.success) {
              throw new Error(result.error)
            }
            return result.data
          } catch (error) {
            handleApiError(error)
          }
        }
    })
}

export const invalidateSessionsQuery = (client: typeof queryClient) => {
    client.invalidateQueries({ queryKey: sessionKeys.sessions() });
};

export const sessionByIdQueryOptions = (sessionId: string) => {
  return queryOptions({
    queryKey: sessionKeys.session(sessionId),
    retry: false,
    queryFn: async () => {
      try {
        const response = await apiClient(`/sessions/${sessionId}`)
        const result = await handleResponse<GetSessionByIdResponse>(response)
        if (!result.success) {
          throw new Error(result.error)
        }

        console.log("current session", result.data.session_overview)
        return result.data.session_overview.session
      } catch (error) {
        handleApiError(error)
      }
    }
  })
}

export const sessionByOnboardingIdQueryOptions = (sessionId: string) => {
    return queryOptions({
      queryKey: sessionKeys.session(sessionId),
      retry: false,
      queryFn: async () => {
        try {
          const response = await apiClient(`/sessions/${sessionId}`)
          const result = await handleResponse<GetSessionByIdResponse>(response)
          if (!result.success) {
            throw new Error(result.error)
          }

          console.log("current session", result.data.session_overview)
          return result.data.session_overview.session
        } catch (error) {
          handleApiError(error)
        }
      }
    })
  }